module.exports = __webpack_public_path__ + "img/clouds.746d1a95.png";